import React from 'react';
import classnames from 'classnames';
import { ManufacturerRatingProperty, Render } from 'types';
import { formatLabelFromProperty } from 'util/index';
import { AdminContentWrapper } from 'components/AdminContent';
import { useFormField, useManufacturerRatingField } from 'types/formik';

function EditField(
  props: Readonly<{
    label?: string;
    property: ManufacturerRatingProperty;
    serviceRatingIndex: number;
    manufacturerIndex: number;
  }>
): Render {
  const [{ value: formRating }, { touched, error }, { setValue: setRating }] = useManufacturerRatingField(
    props.serviceRatingIndex,
    props.manufacturerIndex
  );

  const [{ value: workshop }] = useFormField('workshop');

  const hasError = touched && error;
  const isManufacturerServiceRatingTowingExcluded =
    workshop.workshopServiceRatings?.at(props.serviceRatingIndex)?.excludeForTowers ?? false;

  const value =
    workshop.excludeForTowers || isManufacturerServiceRatingTowingExcluded ? true : formRating.excludeForTowers;
  const fieldName = 'manufacturerExcludeForTowers';

  return (
    <div className='if form-group component workshop-field checkbox'>
      <div className='if checkbox'>
        <input
          checked={value}
          disabled={workshop.excludeForTowers || isManufacturerServiceRatingTowingExcluded}
          onChange={() => {
            setRating({
              ...formRating,
              excludeForTowers: !value,
            });
          }}
          type='checkbox'
          className={classnames('if checkbox-input', hasError && 'is-invalid')}
          data-cy={fieldName}
        />
        <label
          className='if label'
          onClick={() => {
            if (!workshop?.excludeForTowers || !isManufacturerServiceRatingTowingExcluded) {
              setRating({
                ...formRating,
                excludeForTowers: !value,
              });
            }
          }}
        >
          {props.label ?? formatLabelFromProperty(props.property)}
        </label>
        {hasError && <div className='if input-error'>{error}</div>}
      </div>
    </div>
  );
}
const editField = AdminContentWrapper(EditField);

const ReadField = (props: {
  label?: string;
  property: ManufacturerRatingProperty;
  serviceRatingIndex: number;
  manufacturerIndex: number;
}): Render => {
  const [{ value: formRating }] = useManufacturerRatingField(props.serviceRatingIndex, props.manufacturerIndex);

  const [{ value: workshop }] = useFormField('workshop');

  const isManufacturerServiceRatingTowingExcluded =
    workshop?.workshopServiceRatings?.at(props.serviceRatingIndex)?.excludeForTowers ?? false;

  const value =
    workshop?.excludeForTowers || isManufacturerServiceRatingTowingExcluded ? true : formRating?.excludeForTowers;

  return (
    <div className={classnames('component field checkbox-container')}>
      <div className='if label'>{props.label ?? formatLabelFromProperty(props.property)}</div>
      <div data-cy={'WorkshopServiceRating.' + props.property}>{value ? <>Yes</> : <>No</>}</div>
    </div>
  );
};

export function ManufacturerRatingCheckbox(editing: boolean) {
  return editing ? editField : ReadField;
}
